import emotion from 'emotion/dist/emotion.umd.min.js';

const { css } = emotion;

export const thankContainer = css`
  max-width: 700px;
  height: 320px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 600px) {
    padding: 20px;
  }
`

export const imgWrapper = css`
  display:flex;
  justify-content:center;
  padding: 0 0 20px;
`;

export const title = css`
  font-size: 32px;
  font-weight: bold;
  margin: 0;
  text-align: center;
  color: #0d294a;
`

export const paragraph = css`
  text-align: center;
  color:#0d294a;
  font-size: 16px;
  margin: 16px 0;
`